import { readUsers } from "@directus/sdk";
import { getDirectusClient } from "../lib/directus";
const directus = getDirectusClient();

export const ObtenerUsuario = async (idUser) => {
  try {
    const response = await directus.request(
      readUsers({
        fields: ["id", "first_name", "last_name"],
        filter: {
          _and: [
            {
              id: {
                _eq: idUser,
              },
            },
          ],
        },
      })
    );
    return response;
  } catch (error) {
    console.error("Error obteniendo usuario:", error);
    throw error;
  }
};
export const ObtenerUsuarioByRole = async (role) => {
  try {
    const response = await directus.request(
      readUsers({
        fields: ["id", "first_name", "last_name", "role.name"],
        filter: {
          _and: [
            {
              role: {
                name: {
                  _eq: role,
                },
              },
            },
          ],
        },
      })
    );
    return response;
  } catch (error) {
    console.error("Error obteniendo usuario:", error);
    throw error;
  }
};


export const ObtenerUsuariosClientesPorSuperior = async (
  superiorId,
  pageSize,
  page
) => {
  try {
    const response = await directus.request(
      readUsers({
        fields: [
          "id",
          "first_name",
          "last_name",
          "email",
          "documento",
          "role",
          "latitude",
          "longitude",
          "credito",
          "tope_credito",
          "dias_max_credito",
          "bodega.id",
          "bodega.nombre",
          "tipo_cliente",
          "celular",
          "telefono",
          "representante_legal",
          "total_personas",
          "encargado",
          "codigo_establecimiento",
          "circuitos_cliente.circuitos_id",
          "superior",
          "idremoto",
        ],
        limit: pageSize,
        page: page,
        filter: {
          _and: [
            {
              superior: {
                id: {
                  _eq: superiorId,
                },
              },
            },
            {
              role: {
                name: {
                  _eq: "clientes",
                },
              },
            },
          ],
        },
      })
    );
    return response;
  } catch (error) {
    console.error("Error obteniendo usuarios por superior:", error);
    throw error;
  }
};

export const ObtenerUsuariosPorSuperior = async (
  superiorId,
  pageSize = 10,
  page = 1
) => {
  try {
    const directus = await getDirectusClient();
    const response = await directus.request(
      readUsers({
        fields: [
          "id",
          "first_name",
          "role.name",
          "last_name",
          "email",
          "documento",
          "role.id",
          "superior.id",
          "bodega.id",
          "bodega.nombre",
          "tope_de_prestamo",
          "status",
          "idremoto",
        ],
        limit: pageSize,
        page: page,
        filter: {
          superior: {
            id: {
              _eq: superiorId,
            },
          },

          role: {
            name: {
              _neq: "clientes",
            },
          },
        },
      })
    );
    return response;
  } catch (error) {
    console.error("Error obteniendo usuarios por superior:", error);
    throw error;
  }
};
export const ObtenerUsuarios = async (
  filters,
  userRoleID,
  userBodega,
  pageSize = 10,
  page = 1
) => {
  try {
    const directus = await getDirectusClient();
    const response = await directus.request(
      readUsers({
        fields: [
          "id",
          "first_name",
          "role.name",
          "last_name",
          "email",
          "documento",
          "role.id",
          "superior.id",
          "bodega.id",
          "bodega.nombre",
          "tope_de_prestamo",
          "status",
          "idremoto",
        ],
        limit: -1,
        page: page,
        filter: {
          role: {
            name: {
              _neq: "clientes",
            },
          },
          ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
            ? {
                bodega: {
                  id: { _eq: userBodega },
                },
              }
            : {}),
          ...filters,
        },
      })
    );
    return response;
  } catch (error) {
    console.error("Error obteniendo usuarios por superior:", error);
    throw error;
  }
};
export const ObtenerUsuariosCount = async (
  filters,
  userRoleID,
  userBodega,
  pageSize = 10,
  page = 1
) => {
  try {
    const directus = await getDirectusClient();
    const response = await directus.request(
      readUsers({
        fields: [
          "id",
          "first_name",
          "role.name",
          "last_name",
          "email",
          "documento",
          "role.id",
          "superior.id",
          "bodega.id",
          "bodega.nombre",
          "tope_de_prestamo",
          "status",
          "idremoto",
        ],
        limit: pageSize,
        page: page,
        filter: {
          role: {
            name: {
              _neq: "clientes",
            },
          },
          ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
            ? {
                bodega: {
                  id: { _eq: userBodega },
                },
              }
            : {}),
          ...filters,
        },
        aggregate: {
          countDistinct: ["id"],
        },
      })
    );
    return response;
  } catch (error) {
    console.error("Error obteniendo usuarios por superior:", error);
    throw error;
  }
};